import { createContext, type ReactNode } from "react";

/**
 * What a table hands down to its pager: anything to show at the pager's left (the compact table's export button), and whether the
 * table is dense, which makes the pager smaller to match.
 */
export interface TablePagerSettings {
  leading: ReactNode;
  dense: boolean;
}

export const TablePagerContext = createContext<TablePagerSettings>({ leading: null, dense: false });
